import { Component, OnInit } from '@angular/core';
import { ProductService } from 'src/app/core/services/product.service';

@Component({
  selector: 'app-product-category',
  templateUrl: './product-category.component.html',
  styleUrls: ['./product-category.component.scss']
})
export class ProductCategoryComponent implements OnInit {
 //#region ProductCategoryComponent constructor & Ng Events
 constructor(private productService:ProductService) { }
  ngOnInit(): void {
    const languageCode = localStorage.getItem('language');
    this.productService.getAllCategories(languageCode).subscribe((productCategories)=>{
    this.productCategory.categories=productCategories;
     console.log(productCategories);
   });
}
 //#endregion
 //#region getAllCategories Logic
 protected productCategory={
    categories:this.productService.productCategories,
 }
  //#endregion  
}
